import { render } from "./itemLottoDaily.vue?vue&type=template&id=37caef82"
import script from "./itemLottoDaily.vue?vue&type=script&lang=js"
export * from "./itemLottoDaily.vue?vue&type=script&lang=js"

import "./itemLottoDaily.vue?vue&type=style&index=0&id=37caef82&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__